import { createFileRoute, redirect } from "@tanstack/react-router";

// "/" has no page of its own: anonymous users land on /login (via the _authenticated guard),
// signed-in users on /playground (B2).
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/playground" });
  },
});
